var mainNav = mainNav || {};

if (!Object.create) {
    Object.create = (function () {
        function F() {}

        return function (o) {
            if (arguments.length != 1) {
                throw new Error('Object.create implementation only accepts one parameter.');
            }
            F.prototype = o;
            return new F()
        }
    })()
}

jQuery(function ( $ ) {

    $.fn.navControls = function( options ) {
        return this.each(function() {
            var navControls = Object.create(mainNav.navControls);
            navControls.init(this, options);
        });
    };

    $.fn.navControls.options = {
        triggerSelector: '.showHide-trigger',
     };

    mainNav.navControls = {

        init (elem, options) {
            var self = this;

            self.buildOverlay();

            self.$container = $(elem);
            self.$navCat = self.$container.find(".nav-cat__label");
            self.$navDrop = self.$container.find(".nav-dropdown");
            self.$overLay = $(".navigation__overlay");

            // mobile
            self.$touchNav = self.$container.find(".touch-nav");
            self.$touchTrigger = self.$container.find(".header-mobile__trigger");
            self.$touchToggle = self.$container.find(".touch-menu__cat-link--dropdown");


            // Crisis Alert
            self.$crisisWrapper = self.$container.find(".nav-alert");
            self.$crisisTrigger = self.$crisisWrapper.find(".nav-alert__button");
            self.$crisisOverlay = self.$crisisWrapper.find(".crisis-overlay");
            self.$crisisInfo = self.$crisisWrapper.find(".crisis-footer__trigger");
            self.$crisisBack = self.$crisisWrapper.find(".crisis-det__back");

            // Nav Search
            self.$searchWrapper = self.$container.find(".nav-search");
            self.$searchForm = self.$searchWrapper.find(".nav-form")
            self.$searchTrigger = self.$searchWrapper.find(".nav-search__button");
            self.$searchOverlay = self.$searchWrapper.find(".search-overlay");
            self.$searchInput = self.$searchWrapper.find(".nav-form__input");
            self.$searchTagsWrap = self.$searchWrapper.find(".form-pre");
            self.$searchTags = self.$searchWrapper.find(".form-pre__link");

            // Mobile Search
            self.$mobileWrapper = self.$container.find(".touch-search");
            self.$mobileInput = self.$mobileWrapper.find(".touch-search__input");
            self.$mobileTagsWrap = self.$mobileWrapper.find(".touch-prefill");
            self.$mobileTags = self.$mobileWrapper.find(".touch-prefill__link");


            self.bindElements();

        },

        bindElements () {
            var self = this;

            self.$navCat.on( "mouseover touchend" , function(e) {

                if( $(window).outerWidth() <= 1024 && $(this).parent().hasClass("nav__cat--tablet")) {
                    //self.$crisisWrapper.removeClass("crisis-open");
                    self.toggleSearch( false );
                    return true;
                } else {
                    e.preventDefault();

                    // self.$crisisWrapper.removeClass("crisis-open");
                    // self.toggleSearch( false );
                    self.toggleMenu( this )
                    return false;
                }
            });

            self.$navCat.on("click touchend", function(e) {
                if( $(window).outerWidth() <= 1024 && $(this).parent().hasClass("nav__cat--tablet") ){
                } else if( !$(this).hasClass("nav-cat__label--link")) {
                } else {
                   e.preventDefault();
                }
            })

            $(document).on( "mouseover touchend" , ".navgation__overlay", function(e) {
                e.preventDefault();
                self.killMenu();
            });

            $(document).on( "mouseover" , ".snipe-banner", function(e) {
                self.killMenu();
            });

            $(document).on("mouseleave", function (e) {
                e.preventDefault();
                self.killMenu();
            });

            self.$touchTrigger.on( "click touchend" , function(e) {
                e.preventDefault();

                //self.$crisisWrapper.removeClass("crisis-open");
                self.toggleSearch( false );
                self.$touchNav.toggleClass("active");
                self.$touchNav.find(".sub-active").removeClass( "sub-active" );

                $(".touch-menu__use").attr("xlink:href", "#right-angle" );

            });

            self.$touchToggle.on( "click touchend" , function(e) {
                e.preventDefault()

                self.toggleSub( $(this).parent() );
            });

            self.$crisisTrigger.on( "click touchend" , function(e) {
                //e.preventDefault()

                self.$touchNav.removeClass("active");
                self.toggleSearch( false );

                //self.$crisisWrapper.toggleClass("crisis-open");
                self.$navCat.parent().removeClass("active");
                $(".navgation__overlay").removeClass("active");
                self.$crisisOverlay.removeClass("crisis-toggle");


            });

            self.$crisisInfo.on( "click touchend" , function(e) {
                e.preventDefault()

                self.toggleCrisis();
            });

            self.$crisisBack.on( "click touchend" , function(e) {
                e.preventDefault()

                self.toggleCrisis();
            });

            self.$searchTrigger.on( "click" , function(e) {
               // e.preventDefault()
                self.killMenu()
                //self.$crisisWrapper.removeClass("crisis-open");
                self.$touchNav.removeClass("active");
                self.toggleSearch(true);

            });

            self.$searchInput.on("focus", function() {
                self.$searchTagsWrap.slideDown(300);
            });

            $(self.$searchTags).on( "click touchend" , function(e) {
                e.preventDefault()

                self.searchTag( $(this).data("value"));
                return false;
            });


            self.$mobileInput.on("focus", function() {
                self.$mobileTagsWrap.slideDown(300);
            });

            self.$mobileTags.on( "click touchend" , function(e) {
                e.preventDefault()

                self.mobileSearchTag( $(this).data("value"));
                return false;
            });
        },

        killMenu () {
            var self = this;
            self.$navCat.parent().removeClass("active");
            $(".navgation__overlay").removeClass("active");
        },

        toggleMenu ( target ) {
            var self = this;

            setTimeout(function() {
                self.$navCat.not($(target)).parent().removeClass("active");

                if( $( target ).parent().hasClass("active") ) {
                    $( target ).parent().removeClass("active").addClass("animate");
                    $(".navgation__overlay").removeClass("active");

                    self.timeAnimation( $( target ).parent() );

                } else {
                    $( target ).parent().addClass("active animate");
                    self.timeAnimation( $( target ).parent() );
                    var swapCheck = $(target).next( self.$navDrop ).attr("data-swap");

                    if( eval(swapCheck) && swapCheck !== undefined ) {
                            self.bindSwap( $(target).next( self.$navDrop ) );
                    }

                    $(".navgation__overlay").addClass("active");
                }
            }, 50 )

        },
        timeAnimation (target) {
             setTimeout(function() {
                     $(target).removeClass("animate");
                }, 350);
        },
        // Sets Overlay to handle Off Clicks of menu
        buildOverlay () {
            $(".header").append("<span class='navgation__overlay'></span>");
        },
        // Image Swapping on Hover Functions
        bindSwap (target) {
            var self = this;
            self.$swapDropdown = $(target);
            self.$swapLink = self.$swapDropdown.find(".dropdown-links__link");
            self.$image = self.$swapDropdown.find(".nav-dropdown__image");

            self.$swapLink.on("mouseover", function() {
                self.loadImages( $(this).data("hover-image") )
            });

            self.$swapDropdown.on("mouseout", function() {
                self.loadImages( self.$swapDropdown.data("default-image")  );
            });

            self.preload();
        },

        loadImages( image ) {
            var self = this;
            self.$image.attr("src", image);
        },

        preload() {
            var self = this;
            self.$swapLink.each(function(i,v) {
                var image = new Image();
                    image.src = $(v).data("hover-image");
            });

        },

        toggleSub (target) {
            var icon = $(target).find(".touch-menu__use");

            var swapIcon =  $(icon).attr("xlink:href");

            $(target).toggleClass("sub-active");

            $(icon).attr("xlink:href", swapIcon === "#right-angle" ? "#bar" :  "#right-angle" );
        },

        toggleCrisis (bool) {
            var self = this;
            if ( !bool ) {
                self.$crisisOverlay.toggleClass("crisis-toggle");
            } else {
                self.$crisisOverlay.removeClass("crisis-toggle");
            }

        },

        toggleSearch (bool) {
            var self = this;
            if ( !bool ) {
                $('body').removeClass("search-toggle");
            } else {

                $('body').toggleClass("search-toggle");
            }

        },

        searchTag( value ) {
            var self = this;

            self.$searchInput.val( value ).trigger("change");
            self.$searchForm.trigger("submit");
            return false;
        },

        mobileSearchTag( value ) {
            var self = this;

            self.$mobileInput.val( value ).trigger("change");
            self.$mobileWrapper.trigger("submit");
        }
    };
});
